"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = require("prop-types");
var _classnames = _interopRequireDefault(require("classnames"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const PaymentLogo = props => {
  const {
    src,
    alt,
    size,
    className,
    prefix = '',
    ...otherProps
  } = props;
  const classes = (0, _classnames.default)(className, `${prefix}payment-logo`, size && `${prefix}payment-logo--${size}`);
  return src && _react.default.createElement("span", _extends({}, otherProps, {
    className: classes
  }), _react.default.createElement("img", {
    className: `${prefix}payment-logo__img`,
    src: src,
    alt: alt
  }));
};
var _default = PaymentLogo;
exports.default = _default;